export const USERS_TABLE = {
  colRole: 120,
  colOrganizations: 200,
  colSuperAdmin: 90,
  colProvider: 170,
  colScheme: 90,
  colActions: 80,
}

export const ALL_USERS_TABLE = {
  colOrganizations: 320,
  colSuperAdmin: 90,
  colProvider: 100,
  colScheme: 90,
  colActions: 50,
}
